module.exports = __webpack_public_path__ + "38bce559f1f30aa220c718ea55230a6d.pdf";